import { InjectionToken } from '@angular/core';

export interface GoogleMapConfig {
  apikey: string;
}

export const GOOGLE_MAP_CONFIG = new InjectionToken<GoogleMapConfig>('GOOGLE_MAP_CONFIG');
